import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from "axios"

export const GetLastViewTemplateFromLocal = () => {
    const arr = []

    try {
        const existsData = JSON.parse(localStorage.getItem('lastviewtemplate'))
        arr.push(...existsData.filter(item => Date.now() - Date.parse(item.clickedDate) < 1000 * 60 * 60 * 24))
    }
    catch (e) {}

    arr.sort((a, b) => Date.parse(b.clickedDate) - Date.parse(a.clickedDate))

    return arr
}

export const AddLastViewTemplateToLocal = groupData => {
    const arr = GetLastViewTemplateFromLocal()

    for (let i=0; i<arr.length; i++) {
        if (arr[i].name === groupData.name) return arr
    }

    const newArr = [ { ...groupData, clickedDate: (new Date()).toISOString() }, ...(arr.slice(0, 19)) ]
    localStorage.setItem('lastviewtemplate', JSON.stringify(newArr))

    return newArr
}

export const SaveLastViewTemplateToServerFromLocal = async () => {
    const arr = GetLastViewTemplateFromLocal().reverse()

    try {
        const token = localStorage.getItem('token')
        for (let i=0; i<arr.length; i++) {
            const { name } = arr[i]
            await axios.post(`${GetBaseUrl()}/api/user/last-view-template`, { name }, { headers: { Authorization: `Bearer ${token}` } })
        }
    }
    catch (e) {

    }
    localStorage.setItem('lastviewtemplate', JSON.stringify([]))
}